import apiClient from './client';

const getOrCreateConversation = async (bookingId) => {
  const response = await apiClient.post(`/chat/booking/${bookingId}`, {});
  return response.data.data;
};

const getMessages = async (conversationId) => {
  const response = await apiClient.get(`/chat/conversation/${conversationId}/messages`);
  return response.data.data;
};

const sendMessage = async (conversationId, messageText) => {
  const response = await apiClient.post(`/chat/conversation/${conversationId}/messages`, { messageText });
  return response.data.data;
};

const getUserConversations = async () => {
  const response = await apiClient.get(`/chat/conversations`);
  return response.data.data;
};

export default {
  getOrCreateConversation,
  getMessages,
  sendMessage,
  getUserConversations
};
